import HttpFactory from "~/repository/factory";
import { createPublicRequestConfig } from "~/repository/authSession";
import { ENDPOINTS } from "~/repository/endpoints";
import type { CEPResponse } from "~/types/brazilAPI";

class BrazilAPIModule extends HttpFactory {
  async getCEP(cep: string): Promise<CEPResponse> {
    return await this.get(
      `${ENDPOINTS.BRAZIL_API.CEP}${cep}`,
      {},
      createPublicRequestConfig(),
    );
  }
}

export default BrazilAPIModule;
